import { render, staticRenderFns } from "./MultiBarComponent.vue?vue&type=template&id=f3ffd97e"
import script from "./MultiBarComponent.vue?vue&type=script&lang=js"
export * from "./MultiBarComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports